module.exports = __webpack_public_path__ + "static/img/jiantou.f491b5be.svg";